/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Signup_SubtitleInputs */

const en_auth_signup_subtitle = /** @type {(inputs: Auth_Signup_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start building ATS-ready resumes for Europe`)
};

const de_auth_signup_subtitle = /** @type {(inputs: Auth_Signup_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erstelle ATS-optimierte Lebensläufe für Europa`)
};

const fr_auth_signup_subtitle = /** @type {(inputs: Auth_Signup_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commence à créer des CV optimisés pour les ATS en Europe`)
};

const es_auth_signup_subtitle = /** @type {(inputs: Auth_Signup_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empiece a crear currículums optimizados para ATS en Europa`)
};

const it_auth_signup_subtitle = /** @type {(inputs: Auth_Signup_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inizia a creare curriculum vitae ottimizzati per ATS in Europa`)
};

const nl_auth_signup_subtitle = /** @type {(inputs: Auth_Signup_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Begin met het maken van ATS-geoptimaliseerde CV's voor Europa`)
};

const pl_auth_signup_subtitle = /** @type {(inputs: Auth_Signup_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zacznij tworzyć CV zoptymalizowane pod ATS na rynek europejski`)
};

const fi_auth_signup_subtitle = /** @type {(inputs: Auth_Signup_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aloita ATS-optimoitujen ansioluetteloiden luominen Eurooppaan`)
};

const da_auth_signup_subtitle = /** @type {(inputs: Auth_Signup_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Begynd at bygge ATS-klar CV'er til Europa`)
};

const sv_auth_signup_subtitle = /** @type {(inputs: Auth_Signup_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Börja bygga ATS-optimerade CV:n för Europa`)
};

/**
* | output |
* | --- |
* | "Start building ATS-ready resumes for Europe" |
*
* @param {Auth_Signup_SubtitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const auth_signup_subtitle = /** @type {((inputs?: Auth_Signup_SubtitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Signup_SubtitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_auth_signup_subtitle(inputs)
	if (locale === "fr") return fr_auth_signup_subtitle(inputs)
	if (locale === "es") return es_auth_signup_subtitle(inputs)
	if (locale === "it") return it_auth_signup_subtitle(inputs)
	if (locale === "nl") return nl_auth_signup_subtitle(inputs)
	if (locale === "pl") return pl_auth_signup_subtitle(inputs)
	if (locale === "fi") return fi_auth_signup_subtitle(inputs)
	if (locale === "da") return da_auth_signup_subtitle(inputs)
	if (locale === "sv") return sv_auth_signup_subtitle(inputs)
	return en_auth_signup_subtitle(inputs)
});